import { Spinner } from "../../Loading/Spinner";
import { useSuperAdminEventos } from "../../../context/SuperAdmin/EventsContext";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import { RowEventos } from "./RowEventos";

const EventosTable = () => {
  const { isLoadingTable, eventos, selectedOpt } = useSuperAdminEventos();

  if (!selectedOpt) {
    return (
      <Grid item>
        <Box
          sx={{
            padding: 2,
            textAlign: "center",
            width: 1,
            borderRadius: "10px",
            backgroundColor: "#EFF3F7",
          }}
        >
          Por favor selecciona una opción
        </Box>
      </Grid>
    );
  }

  if (isLoadingTable) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <Grid item>
      <TableContainer
        sx={{
          width: "100%",
          margin: "auto",
          borderRadius: 2,
          overflow: "hidden",
          marginTop: "10px",
        }}
      >
        <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
          <TableHead sx={{ height: 20 }}>
            <TableRow>
              <StyledTableCell>N°</StyledTableCell>
              <StyledTableCell>Nombre</StyledTableCell>
              <StyledTableCell>Organizacion</StyledTableCell>
              <StyledTableCell>Acción</StyledTableCell>
              <StyledTableCell>Aplicativo</StyledTableCell>
              <StyledTableCell>Fecha</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {eventos.length > 0 ? (
              eventos.map((evento, index) => (
                <RowEventos
                  key={evento.id_auditoria}
                  evento={evento}
                  i={index + 1}
                />
              ))
            ) : (
              <TableRow>
                <StyledTableCell
                  colSpan={9}
                  sx={{
                    paddingTop: "12px",
                    paddingBottom: "12px",
                    textAlign: "center",
                  }}
                >
                  No hay campos aún
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default EventosTable;
